import { render } from "./index.vue?vue&type=template&id=1de4c9bb&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modules/Authentication/ConfirmMail/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1de4c9bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1de4c9bb', __exports__)) {
    api.reload('1de4c9bb', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1de4c9bb&ts=true", () => {
    api.rerender('1de4c9bb', render)
  })

}


export default __exports__